import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "components/Page";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { Select } from "react-inputs-validation";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Textbox } from "react-inputs-validation";
import * as Yup from 'yup';
import {
  Button, Card, CardBody, CardHeader, Col, Row,

  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Dropdown,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  CardFooter
} from "reactstrap";
import "../../styles/estilos.css";
import "./styles.scss";

import {
  MdInsertChart,
  MdPersonPin,
  MdExitToApp,
  MdFormatListBulleted,
  MdHome,
  MdArrowDropDown,
  MdLaunch,
} from "react-icons/lib/md";
import { apiGet } from "../../api";
import { ambienteAplicacion, urlFVinculacion, urlGuardarRenovaciones, urlSolicitarCartaNoSiniestroa, urlSolicitarCoberturaProvicional } from "../../constants/urls";
import moment from "moment";
import ConfirmDialog from "./ConfirmDialog";
import { FetchExportarEccel, FetchListadoRenovaciones, validarBotonCarta, validarBotonContinuar, validarBotonFv, validarBotonRecompra, validarBotonRenovar, validarCoberturaProvisional, validarPolizaVencida } from "../../redux/actions/aLogin";
import Formulario from "../Generales/Formulario";
import InputDialog from "./InputDialog";

class ListaRenovaciones extends React.Component {
  constructor(props) {
    super(props);
    const { datosRenovaciones } = this.props;
    this.state = {
      activePage: 1,
      renovacionesOri: datosRenovaciones.datosRenovaciones,
      datosRenovaciones: datosRenovaciones.datosRenovaciones,
      numeroElementos: datosRenovaciones.datosRenovaciones.length,
      filtro: "",
      filtrosRenovaciones: {
        "color": "",
        "marca": "",
        "nombreContratante": "",
        identificacionContratante: '',
        placa: '',
        marca: '',
        modelo: '',
        polDescripcionSeguro: '',
        numeroPolizaEmision: '',
        reCarritoContador: '',
        sucursal: '',
        reEstadoRenovacion: ''
      },
      filtroselect: datosRenovaciones.datosFiltroRenovaciones,
      filtroValor: "todas",
      polizaSelected: null,
      isLoadingRenovaciones: false,
      isConfirmOpen: false,
      confirmAction: null,
      titulo: '',
      isInputOpen: false,
      confirmInputAction: null,
      email: '',
      errors: null,
      message: '',
      values: {
        fechaInicio: '2020-12-03',
        fechaFin: '2026-12-03'
      }

    };

    console.log('datosRenovaciones', datosRenovaciones)
  }

  toggleConfirm = () => {
    this.setState((prevState) => ({
      isConfirmOpen: !prevState.isConfirmOpen,
    }));
  };

  toggleConfirmInput = () => {
    this.setState((prevState) => ({
      isInputOpen: !prevState.isInputOpen,
    }));
  };


  onFiltrar = async () => {
    const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

    await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones);

  }

  onDescargarExcel = async () => {
    const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

    await this.props.descargarExcel(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones, this.props.history);

  }





  handleKeyDown = (event) => {

    this.onFiltrar()


    // Puedes ejecutar aquí la acción que desees al presionar Enter

  };


  handlePageChange = (pageNumber) => {

    this.setState({ activePage: pageNumber });
  };

  onSort = (event) => {

    console.log('sortedData', sortedData)
    const sortedData = [...this.state.datosRenovaciones.slice(1)].sort((a, b) => {
      let value1 = a[event.field];
      let value2 = b[event.field];

      return event.order === 1 ? value1 - value2 : value2 - value1;
    });

    console.log('sortedData', sortedData)

    // this.setState({datosRenovaciones: [{}, ...sortedData]}); // Recombina los datos manteniendo la primera fila fija
  };



  async componentDidMount() {







    this.state.datosRenovaciones = this.state.datosRenovaciones.map(item =>
      item.polDescripcionSeguro === "PITS"
        ? { ...item, polDescripcionSeguro: "PractiAuto" }
        : item
    );
  }


  ConfirmDialog = ({ isOpen, toggle, message, onConfirm }) => {
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Confirmación</ModalHeader>
        <ModalBody>
          {message}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { onConfirm(); toggle(); }}>
            Confirmar
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  /**
   * Filtra información de la tabla de a cuerdo a los filtros realizados por el usuario
   */
  handleAplicarFiltro = () => {
    let { filtro, renovacionesOri, filtroValor } = this.state;
    filtro = filtro.toUpperCase();

    const cotizaciones = renovacionesOri.filter(
      ({ polPlacas, polIdentificacionesAsegurados, polDescripcionRamo,
        fechaCreacion, nombreContratante, numeroCompra, estado, placa,
        traMetodoPago, forpago, refInterna, traEstadoPlacetoPay, numeroitems, estadoFirma, estadoInspeccion, total }) => {
        if (!polPlacas) polPlacas = "";
        if (!polIdentificacionesAsegurados) polIdentificacionesAsegurados = "";

        if (!fechaCreacion) fechaCreacion = "";
        if (!nombreContratante) nombreContratante = "";
        if (!numeroCompra) numeroCompra = "";

        if (!forpago) forpago = "";
        if (!refInterna) refInterna = "";
        if (!traEstadoPlacetoPay) traEstadoPlacetoPay = "";
        if (!estadoFirma) estadoFirma = "";
        if (!estadoInspeccion) estadoInspeccion = "";
        if (!total) total = "";

        console.log('filtroValor', filtroValor)

        const filtroEstado = filtroValor === "todas" || estado == filtroValor;

        return (
          (polPlacas.indexOf(filtro) > -1 ||
            placa.toString().indexOf(filtro) > -1 ||
            fechaCreacion.toString().indexOf(filtro) > -1 ||
            nombreContratante.indexOf(filtro) > -1 ||
            numeroCompra.toString().indexOf(filtro) > -1 ||
            //numeroitems.toString().indexOf(filtro) > -1 ||
            forpago.toString().toUpperCase().indexOf(filtro) > -1 ||
            refInterna.toString().indexOf(filtro) > -1 ||
            traEstadoPlacetoPay.indexOf(filtro) > -1 ||
            estadoFirma.indexOf(filtro) > -1 ||
            estadoInspeccion.indexOf(filtro) > -1 ||
            total.toString().indexOf(filtro) > -1 ||
            polIdentificacionesAsegurados.indexOf(filtro) > -1) &&
          filtroEstado
        );
      }
    );
    this.setState({ datosRenovaciones: cotizaciones });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.datosRenovaciones !== prevProps.datosRenovaciones) {
      this.setState({
        renovacionesOri: this.props.datosRenovaciones.datosRenovaciones,
        datosRenovaciones: this.props.datosRenovaciones.datosRenovaciones,
        numeroElementos: this.props.datosRenovaciones.datosRenovaciones.length,
        filtroselect: this.props.datosRenovaciones.datosFiltroRenovaciones,
      });
    }
    if (prevState.filtroValor !== this.state.filtroValor) {
      this.handleAplicarFiltro();
    }
  }

  async componentDidMount() {
    const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

    await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado);
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }



  obtenerEstado = (estado) => {
    switch (estado) {
      case 'EN_PROCESO':
        return 'En proceso'

        break;

      case 'En proceso':
        return 'En proceso'

        break;

      case 'POR_RENOVAR':
        return 'Renovación pendiente'

        break;

      case 'Renovación pendiente':
        return 'Renovación pendiente'

        break;

      case 'NO_SINIESTROS_FIRMADA':
        return 'Confirmación de no siniestros firmada'

        break;

      case 'En cobertura provisional':
        return 'En cobertura provisional'

        break;

      case 'Confirmación de no siniestros firmada':
        return 'Confirmación de no siniestros firmada'

        break;

      default:
        return ''
        break;
    }
  }

  textosCargando() {
    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente"
    ) {
      return "Cargando Lista de Renovaciones...";
    }

    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario === "cliente"
    ) {
      return "Cargando Lista de Renovaciones...";
    }
  }


  onClick = async (id, event, forpago) => {

    event.preventDefault();
    if (forpago !== "NI") {
      this.props.history.push({
        pathname: "/final-cotizacion-detalle",
        search: `?id=${id}&estado=APROBADO&resumen=1`, //agregar parametros de la url,
      });
    } else {
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${id}`, //agregar parametros de la url,
      });
    }
  };


  bodyVerDetalles = (compras) => {

    /**
    *  Ir a la pantralla de recompra
    */
    const onClickRenovacion = async () => {
      console.clear();
      this.props.history.push({
        pathname: "/renovacion",
        search: `?id=${compras.id}`,
      });
    }


    const onClickRecompra = async (id, renovacion) => {
      this.props.history.push({
        pathname: "/recompra",
        search: `?id=${id}&renovacion=${renovacion}`

      });

    }

    const onClickFV = async (renovacion) => {


      let fv = await obtenerFV(renovacion.reIdCarrito)

      if (fv.transaccion) {
        if (fv.pasarPantallaFormulario) {

          this.props.history.push({
            pathname: "/formulario-vinculacion-renovacion",
            search: `?url=${fv.urlFormulario}&id=${renovacion.reIdCarrito}`,
          });
        } else {

          this.props.history.push({
            pathname: "/formulario-vinculacion-renovacion",
            search: `?haveForm=VH`,
          });
        }
      }
    }

    const obtenerFV = async (idCarrito) => {

      //return {transaccion: true}
      try {

        const url = `${urlFVinculacion}${idCarrito}`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Error al obtener la siniestralidad. Intente nuevamente más tarde.');
        }

        const json = await response.json();
        return json;
      } catch (error) {
        console.error('Error en validarSiniestralidad:', error);
        return {
          transaccion: false,
          mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
        };
      }
    }



    const onClickContinuarProceso = async (idCarrito, anio, producto, id, aplicarRecompra = false, productoExterno = false, compras) => {

      const yearVariable = parseInt(anio); // Ejemplo de año en la variable
      const currentYear = moment().year(); // Obtiene el año actual con moment()

      const difference = currentYear - yearVariable;
      const bloquearFullCobertura = difference >= 15


      if (aplicarRecompra) {

        this.props.history.push({
          pathname: "/forma-pago",
          search: `?id=${idCarrito}`

        });
      } else {
        if (compras.esRecotizacion) {
          this.props.history.push({
            pathname: "/resumen-cotizacion",
            search: `?id=${idCarrito}&paso=resumen&codigoProductoEspecial=${obtenerCodigoEspecial2(compras.polDescripcionSeguroVer)}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`
          });


        } else {

          this.props.history.push({
            pathname: "/resumen-cotizacion-renovacion",
            search: `?id=${idCarrito}&paso=resumen&codigoProductoEspecial=${productoExterno ? 'externo' : producto}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        }


      }




      const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

      await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, id, resultado);




    }



    const onClickContinuarBK = async (numeroPolizaEmision, anio, renovar, codigoEspecial, id) => {
      // eslint-disable-next-line no-restricted-globals
      const answer = confirm(`¿Estás seguro de que deseas realizar la ${renovar ? 'renovación' : 'cotización'}?`)
      if (answer) {
        renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, id)
      }
    }


    const onClickContinuar = (numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2) => {
      this.setState({
        isConfirmOpen: true,
        message: `¿Estás seguro de que deseas realizar la ${renovar ? 'renovación' : 'recotización'}?`,
        confirmAction: () =>
          renovarPoliza(numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2),
      });
    };

    const onClickContinuarSolicitarCobertura = (idRenovacion, email) => {


      if (!email) {

        this.setState({
          titulo: 'Solicitud de cobertura provisional',
          isInputOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de carta de no siniestros?`,
          confirmInputAction: async () => {

            let validador = await validateForm()

            console.log('validador', validador)

            if( validador){

              solicitarCobertura(idRenovacion, this.state.email)
              this.toggleConfirmInput()

            }else{

            }



          }
          // solicitarCarta(idRenovacion),
        });



      } else {

        this.setState({
          isConfirmOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de cobertura provicional?`,
          confirmAction: () =>
            solicitarCobertura(idRenovacion),
        });
      }

    };

    const getSchema = () => {


      return (

        Yup.object(
          {
            email: Yup
              .string()
              .trim()
              .lowercase()
              .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "El email no es válido"
              )
              .required("El email es obligatorio")
          }
        )

      )

    }


    const validateForm = async () => {


      try {
        await getSchema().validate({ email: this.state.email }, { abortEarly: false });
        this.setState({
          errors: null
        })
        return true;
      } catch (err) {


        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });

        console.log('newErrors', consolidateChildKeys(newErrors))

        this.setState({
          errors: newErrors.email
        })



        //  setError(consolidateChildKeys(newErrors));
        return false;
      }
    };

    function consolidateChildKeys(inputData) {
      const result = {};

      for (const key in inputData) {
        const [parentKey, childKey] = key.split('.'); // Dividir clave en padre e hijo

        if (childKey) {
          // Si es una clave hija, consolidar en el padre
          result[parentKey] = inputData[key];
        } else if (!(parentKey in result)) {
          // Si es una clave padre y aún no está consolidada, agregarla
          result[parentKey] = inputData[key];
        }
      }

      return result;
    }


    const onClickContinuarSolicitarCartaNoSiniestros = (idRenovacion, email) => {


      if (!email) {

        this.setState({
          titulo: 'Solicitud de carta de no siniestros',
          isInputOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de carta de no siniestros?`,
          confirmInputAction: async () => {

            let validador = await validateForm()

            console.log('validador', validador)

            if( validador){

              solicitarCarta(idRenovacion, this.state.email)
              this.toggleConfirmInput()

            }else{

            }
           
          }
          // solicitarCarta(idRenovacion),
        });

      } else {

        this.setState({
          isConfirmOpen: true,
          message: `¿Estás seguro de que deseas realizar la solicitud de carta de no siniestros?`,
          confirmAction: () =>
            solicitarCarta(idRenovacion),
        });
      }

    };


    const mostrarCobertura = (renovacion) => {
      let validador = true

      if (renovacion.procesadoCorreoCobP) {
        validador = false
      } else if (renovacion.aplicarRecompra) {
        validador = false
      }

      return validador
    }


    const mostrarCarta = (renovacion) => {
      let validador = true
      let hoy = new Date();

      if (renovacion.procesadoCorreoNoS) {
        validador = false
      } else if (!renovacion.procesadoCorreoCobP) {
        validador = false
      } else if (renovacion.aplicarRecompra) {
        validador = false
      }

      return validador
    }



    const obtenerCodigoEspecial = (producto) => {

      switch (producto) {
        case 'AIGAUTO':
          return 'AIGAUTO'
          break;
        case 'AIG AUTO':
          return 'AIGAUTO'
          break;

        case 'PRACTIAUTO':
          return 'PRACTIAUTO'
          break;

        default:
          return ''
          break;
      }
    }


    const obtenerCodigoEspecial2 = (producto) => {

      switch (producto) {
        case 'AIGAUTO':
          return 'comparador'
          break;
        case 'AIG AUTO':
          return 'comparador'
          break;

        case 'PRACTIAUTO':
          return 'pits'
          break;

        default:
          return ''
          break;
      }
    }







    const renovarPoliza = async (numeroPolizaEmision, anio, renovar, codigoEspecial, id, codigoEspecial2) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })

      const yearVariable = parseInt(anio); // Ejemplo de año en la variable
      const currentYear = moment().year(); // Obtiene el año actual con moment()

      const difference = currentYear - yearVariable;
      const bloquearFullCobertura = difference >= 15


      //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)





      const data = await apiGet(`${urlGuardarRenovaciones}${numeroPolizaEmision}${!renovar ? '&esRecotizacion=true' : ''}&producto=${codigoEspecial} `)

      console.log('fata', data)



      if (data.transaccion) {

        if (renovar) {

          this.props.history.push({
            pathname: "/resumen-cotizacion-renovacion",
            search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=${codigoEspecial}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        } else {


          this.props.history.push({
            pathname: "/resumen-cotizacion",
            search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=${codigoEspecial2}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`

          });

        }





        const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

        await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, id, resultado);





      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })




    }

    const solicitarCobertura = async (idRenovacion, email= null) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })



      //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)





      const data = await apiGet(`${urlSolicitarCoberturaProvicional}${idRenovacion}${email ? `&email=${email}`: ''} `)

      console.log('data', data)



      if (data.transaccion) {








      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })

      const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;


      await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones);

      this.setState({
        email: ''
      })


    }

    const solicitarCarta = async (idRenovacion, email = null) => {


      this.setState({
        isLoading: true,
        isLoadingRenovaciones: true
      })



      //return console.log('yearVariable', yearVariable, currentYear, difference, bloquearFullCobertura)





      const data = await apiGet(`${urlSolicitarCartaNoSiniestroa}${idRenovacion}${email ? `&email=${email}`: ''}`)

      console.log('fata', data)



      if (data.transaccion) {

   








      } else {
        if (data.errorDescripcion && data.errorDescripcion != '') {
          this.setState({
            tieneError: true,
            mensajeError: data.errorDescripcion
          })
        }
      }

      this.setState({
        isLoading: false,
        isLoadingRenovaciones: false
      })

      const resultado = `${moment(this.state.values.fechaInicio).format('DD-MM-YYYY')} | ${moment(this.state.values.fechaFin).format('DD-MM-YYYY')}`;

      await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones);

      this.setState({
        email: ''
      })



    }




    return (
      <div key={compras.id}>
        <Row>
          <Col sm='12'>

            {
              validarBotonRecompra(compras) &&
              <React.Fragment>

                {
                  <Button
                    className={"btn btn-primary"}
                    onClick={(e) => onClickRecompra(compras.reidPoliza, compras.id)}
                    style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                  >
                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                    {'Recompra'}
                  </Button>

                }


              </React.Fragment>
            }

            {
              validarCoberturaProvisional(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={() => {

                    onClickContinuarSolicitarCobertura(compras.id, compras.emailContratante)

                  }}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Solicitar Cobertura provisional'}
                </Button>
              </React.Fragment>
            }

            {
              validarBotonCarta(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={() => {

                    onClickContinuarSolicitarCartaNoSiniestros(compras.id, compras.emailContratante)
                  }}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Solicitar Carta no Siniestros'}
                </Button>
              </React.Fragment>
            }

            {

              validarBotonRenovar(compras) &&
              //   (!compras.aplicarRecompra && (compras.estado == 'NO_SINIESTROS_FIRMADA' || compras.estado == 'Confirmación de no siniestros firmada')) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => {
                    //  onClickContinuar(compras.numeroPolizaEmision, compras.anio, true, obtenerCodigoEspecial(compras.polDescripcionSeguro), compras.id)
                    this.props.history.push({
                      pathname: "/renovacion",
                      search: `?id=${compras.id}`

                    });

                  }
                  }
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Renovar'}
                </Button>
              </React.Fragment>
            }

            {
              validarBotonContinuar(compras) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => onClickContinuarProceso(compras.reIdCarrito, compras.anio, compras.reProductoNuevo, compras.id, compras.aplicarRecompra, compras.productoExterno, compras)}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Continuar'}
                </Button>
              </React.Fragment>
            }


            {

              validarBotonFv(compras) &&

              <Button
                className={"btn btn-primary"}
                onClick={(e) => onClickFV(compras)}
                style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
              >
                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                {'Completar formulario de vinculación'}
              </Button>



            }

            {
              (!compras.aplicarRecompra && compras.estado == 'VENCIDAS' && !compras.productoExterno) &&

              <React.Fragment>

                <Button
                  className={"btn btn-primary"}
                  onClick={(e) => onClickContinuar(compras.numeroPolizaEmision, compras.anio, false, obtenerCodigoEspecial(compras.polDescripcionSeguroVer), compras.id, obtenerCodigoEspecial2(compras.polDescripcionSeguroVer))}
                  style={{ margin: "auto", marginTop: 10, marginLeft: 0 }}
                >
                  <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                  {'Recotización'}
                </Button>
              </React.Fragment>
            }

            {
              (!compras.aplicarRecompra && (compras.estado == 'NO_RENOVADAS' || compras.estado == 'NO_RENOVABLES' || compras.estado == 'NO_RENOVABLE' || compras.estado == 'FIRMA_RECHAZADA_COBERTURA_PROVISIONAL' || compras.estado == 'FIRMA_RECHAZADA_NO_SINIESTROS')) &&

              <React.Fragment>

                <p>
                  {compras.mensajeNoRenovables}
                </p>
              </React.Fragment>
            }


          </Col>
        </Row>





      </div >

    );
  };

  render() {


    const { activePage, numeroElementos } = this.state;

    const fin = activePage * 10;
    const inicio = fin - 10;


    let textoBoton = "DETALLES RENOVACIÓN";
    if (
      this.props.datosUsuario.usu_tipo_usuario &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente"
    ) {
      textoBoton = "DETALLES RENOVACIÓN";
    }

    const {
      filtroselect,
      filtroValor,
    } = this.state;

    return (
      <LoadingScreen
        loading={this.props.datosRenovaciones.isLoadingRenovaciones || this.state.isLoadingRenovaciones}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title={
            this.props.datosUsuario.usu_tipo_usuario &&
              this.props.datosUsuario.usu_tipo_usuario !== "cliente"
              ? "Listado de Renovaciones"
              : "Listado de Renovaciones"
          }
          breadcrumbs={[
            {
              name:
                this.props.datosUsuario.usu_tipo_usuario &&
                  this.props.datosUsuario.usu_tipo_usuario !== "cliente"
                  ? "Listado de Renovaciones"
                  : "Listado de Renovaciones",
              active: true,
            },
          ]}
        >
          <div className="container">


            <div className="row p-3">


              {Array.isArray(filtroselect) && [...filtroselect]
                .sort((a, b) => (b.value || 0) - (a.value || 0))
                .map((item, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-12 text-center my-3">
                    <Card style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #ddd"
                    }}>
                      <CardBody style={{
                        padding: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                      }}>
                        <span style={{
                          fontSize: "2.5rem",

                          color: "#6C757D"
                        }}>
                          {item.value !== undefined ? item.value : 0}
                        </span>
                      </CardBody>
                      <CardFooter style={{
                        backgroundColor: "#E9ECEF",
                        color: "#6C757D",
                        paddingRight: "12px",
                        paddingLeft: "12px",
                        textAlign: "center",
                        fontSize: "1rem",
                        fontWeight: "bold",
                        minHeight: "70px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        {item.name}
                      </CardFooter>
                    </Card>
                    {/*    <div className="contador">
                    <span className="display-4 d-block">
                      {item.value !== undefined ? item.value : 0}
                    </span>
                    <span className="label" style={{ color: '#001871' }}>{item.name}</span>
                  </div> */}
                  </div>
                ))}
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </div>


          </div>




          <Formulario
            values={this.state.values}
            esRenovacion={true}
            nuevoCarrito={true}
            codigoFormulario={'formulario-rango-fechas'}
            onSubmit={async (values, tieneErrores, errores) => {

              console.log('vererrores', values, tieneErrores, errores)

              if (!tieneErrores) {


                const resultado = `${moment(values.fechaInicio).format('DD-MM-YYYY')} | ${moment(values.fechaFin).format('DD-MM-YYYY')}`;

                await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo, ambienteAplicacion, null, resultado, this.state.filtrosRenovaciones);

              }

            }}

            onChange={(id, valor) => {




              console.log('values', valor)

              this.setState({
                values: valor
              })

            }}

            setValuesInicial={(values) => {



            }}


          ></Formulario>






          {true && (
            <div>

              <div className="d-flex justify-content-end" style={{ marginBottom: 20 }}>
                <Button
                  className="btn btn-primary"
                  onClick={() => this.onDescargarExcel()}
                >
                  <i className="fa fa-download" aria-hidden="true" /> Exportar a Excel
                </Button>
              </div>



              <Row>



                <Col>
                  <Card body>
                    <DataTable
                      onSort={e => this.onSort(e)}
                      value={[{}, ...this.state.datosRenovaciones]}
                      responsive
                      className="p-datatable-customers"
                      rowHover
                      paginator={this.state.datosRenovaciones.length > 0}
                      rows={10}
                      rowsPerPageOptions={[10, 25, 50]}
                      emptyMessage="No se han encontrado resultados"
                      resizableColumns
                    //currentPageReportTemplate="Visualizando {first} hasta {last} de {totalRecords} registros"
                    //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    >







                      <Column
                        className="counter"
                        field="contador"
                        header="#"
                        style={{ width: "60px" }}
                      />

                      <Column
                        field="noItems"
                        header="# Ítems"
                        sortable={false}
                        style={{ width: "100px" }}
                      />

                      {/*   <Column
                        field="id"
                        header="# id"
                        sortable
                        style={{ width: "100px" }}
                      /> */}



                      <Column
                        field="fechaCreacion"
                        header="Inicio de vigencia"
                        sortable={false}
                        style={{ width: "100px" }}
                      />

                      <Column
                        field="mesCaducidad"
                        header="Fin de vigencia"
                        sortable={false}
                        style={{ width: "100px" }}
                      />


                      {/*     <Column
                        header="Contratante"
                        field="nombreContratante"
                        sortable
                        style={{ width: "150px" }}
                      /> */}

                      <Column
                        className="counter"
                        field="nombreContratante"

                        header="Contratante"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ? <Textbox

                            tabIndex="1"

                            onKeyUp={(e) =>
                              e.key === "Enter" ? this.handleKeyDown(e) : null
                            }
                            placeholder="Buscar..."
                            type="text"
                            id="test"
                            name="test"
                            classNameInput={"form-control"}
                            validationOption={{
                              required: false
                            }

                            }

                            value={this.state.filtrosRenovaciones.nombreContratante}
                            onChange={value => {

                              let nuevoObjeto = { ...this.state.filtrosRenovaciones, nombreContratante: value }
                              this.setState({
                                filtrosRenovaciones: nuevoObjeto
                              })
                            }}
                          />
                            : rowData.nombreContratante
                        }
                      />


                      {/*    <Column
                        header="Nro. de identificación"
                        field="polIdentificacionesAsegurados"
                        sortable
                        style={{ width: "150px" }}
                      /> */}

                      <Column
                        className="counter"
                        field="polIdentificacionesAsegurados"

                        header="Nro. de identificación"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ? <Textbox

                            tabIndex="1"
                            onKeyUp={(e) =>
                              e.key === "Enter" ? this.handleKeyDown(e) : null
                            }
                            validationOption={{
                              required: false
                            }

                            }
                            placeholder="Buscar..."
                            type="text"
                            id="test"
                            name="test"
                            classNameInput={"form-control"}

                            value={this.state.filtrosRenovaciones.identificacionContratante}
                            onChange={value => {
                              let nuevoObjeto = { ...this.state.filtrosRenovaciones, identificacionContratante: value }
                              this.setState({
                                filtrosRenovaciones: nuevoObjeto
                              })
                            }}
                          />
                            : rowData.polIdentificacionesAsegurados
                        }
                      />



                      {/*    <Column
                        header="Vehículo"
                        field="vehiculo"
                        body={(row, options) => {



                          return (
                            options.rowIndex === 0 ? <Textbox

                              tabIndex="1"
                              onKeyUp={(e) =>
                                e.key === "Enter" ? this.handleKeyDown(e) : null
                              }
                              validationOption={{
                                required: false
                              }

                              }
                              placeholder="Buscar..."
                              type="text"
                              id="test"
                              name="test"
                              classNameInput={"form-control"}

                              value={this.state.filtrosRenovaciones.placa}
                              onChange={value => {

                                let nuevoObjeto = { ...this.state.filtrosRenovaciones, placa: value }
                                this.setState({
                                  filtrosRenovaciones: nuevoObjeto
                                })
                              }}
                            /> :
                              <div>
                                <strong>Placa:</strong> {row.placa} <br />
                                <strong>Marca:</strong> {row.marca} <br />
                                <strong>Modelo:</strong> {row.modelo} <br />
                                <strong>Año:</strong> {row.anio}
                              </div>
                          )
                        }}
                        style={{ width: "150px" }}
                      /> */}

                      <Column
                        header="Placa"
                        field="placa"
                        body={(row, options) => {



                          return (
                            options.rowIndex === 0 ? <Textbox

                              tabIndex="1"
                              onKeyUp={(e) =>
                                e.key === "Enter" ? this.handleKeyDown(e) : null
                              }
                              validationOption={{
                                required: false
                              }

                              }
                              placeholder="Buscar..."
                              type="text"
                              id="test"
                              name="test"
                              classNameInput={"form-control"}

                              value={this.state.filtrosRenovaciones.placa}
                              onChange={value => {

                                let nuevoObjeto = { ...this.state.filtrosRenovaciones, placa: value }
                                this.setState({
                                  filtrosRenovaciones: nuevoObjeto
                                })
                              }}
                            /> :
                              Array.isArray(row.vehiculoAll) && row.vehiculoAll.map(vehiculo => {
                                return <p>{vehiculo.rePlaca}</p>
                              })
                          )
                        }}
                        style={{ width: "150px" }}
                      />

                      <Column
                        header="Marca"
                        field="marca"
                        body={(row, options) => {



                          return (
                            options.rowIndex === 0 ? <Textbox

                              tabIndex="1"
                              onKeyUp={(e) =>
                                e.key === "Enter" ? this.handleKeyDown(e) : null
                              }
                              validationOption={{
                                required: false
                              }

                              }
                              placeholder="Buscar..."
                              type="text"
                              id="test"
                              name="test"
                              classNameInput={"form-control"}

                              value={this.state.filtrosRenovaciones.marca}
                              onChange={value => {

                                let nuevoObjeto = { ...this.state.filtrosRenovaciones, marca: value }
                                this.setState({
                                  filtrosRenovaciones: nuevoObjeto
                                })
                              }}
                            /> :

                              Array.isArray(row.vehiculoAll) && row.vehiculoAll.map(vehiculo => {
                                return <p>{vehiculo.reMarca}</p>
                              })
                          )
                        }}
                        style={{ width: "150px" }}
                      />

                      <Column
                        header="Modelo"
                        field="modelo"
                        body={(row, options) => {



                          return (
                            options.rowIndex === 0 ? <Textbox

                              tabIndex="1"
                              onKeyUp={(e) =>
                                e.key === "Enter" ? this.handleKeyDown(e) : null
                              }
                              validationOption={{
                                required: false
                              }

                              }
                              placeholder="Buscar..."
                              type="text"
                              id="test"
                              name="test"
                              classNameInput={"form-control"}

                              value={this.state.filtrosRenovaciones.modelo}
                              onChange={value => {

                                let nuevoObjeto = { ...this.state.filtrosRenovaciones, modelo: value }
                                this.setState({
                                  filtrosRenovaciones: nuevoObjeto
                                })
                              }}
                            /> :
                              Array.isArray(row.vehiculoAll) && row.vehiculoAll.map(vehiculo => {
                                return <p>{vehiculo.reModelo}</p>
                              })
                          )
                        }}
                        style={{ width: "150px" }}
                      />
                      {/*  <Column
                        header="Marca"
                        field="marca"
                        sortable
                        style={{ width: "150px" }}
                      /> */}

                      {/*    <Column
                        header="Placa"
                        field="placa"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/*   <Column
                        header="Año"
                        field="anio"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/*      <Column
                        header="Ramo"
                        field="polDescripcionRamo"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      {/*     <Column
                        header="Producto"
                        field="polDescripcionSeguro"
                        sortable
                        style={{ width: "100px" }}
                      /> */}

                      <Column
                        className="counter"
                        field="polDescripcionSeguroVer"

                        header="Producto"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ? <Textbox

                            tabIndex="1"
                            onKeyUp={(e) =>
                              e.key === "Enter" ? this.handleKeyDown(e) : null
                            }
                            validationOption={{
                              required: false
                            }

                            }
                            type="text"
                            id="test"
                            placeholder="Buscar..."
                            name="test"
                            classNameInput={"form-control"}

                            value={this.state.filtrosRenovaciones.polDescripcionSeguro}
                            onChange={value => {

                              let nuevoObjeto = { ...this.state.filtrosRenovaciones, polDescripcionSeguro: value }
                              this.setState({
                                filtrosRenovaciones: nuevoObjeto
                              })
                            }}
                          />
                            : rowData.polDescripcionSeguroVer
                        }
                      />
                      {/*    <Column
                        header="Número Póliza"
                        field="numeroPolizaEmision"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      <Column
                        className="counter"
                        field="numeroPolizaEmision"

                        header="Número Póliza"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ? <Textbox

                            tabIndex="1"
                            onKeyUp={(e) =>
                              e.key === "Enter" ? this.handleKeyDown(e) : null
                            }
                            validationOption={{
                              required: false
                            }

                            }
                            type="text"
                            placeholder="Buscar..."
                            id="test"
                            name="test"
                            classNameInput={"form-control"}

                            value={this.state.filtrosRenovaciones.numeroPolizaEmision}
                            onChange={value => {

                              let nuevoObjeto = { ...this.state.filtrosRenovaciones, numeroPolizaEmision: value }
                              this.setState({
                                filtrosRenovaciones: nuevoObjeto
                              })
                            }}
                          />
                            : rowData.numeroPolizaEmision
                        }
                      />
                      {/* <Column
                        header="Número Compra"
                        field="numeroCompra"
                        sortable
                        style={{ width: "100px" }}
                      /> */}

                      {/*   <Column
                        header="Sucursal"
                        field="sucursal"
                        sortable
                        style={{ width: "100px" }}
                      /> */}

                      {/*    <Column
                        className="counter"
                        field="sucursal"

                        header="Sucursal"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ? <Textbox

                            tabIndex="1"
                            type="text"
                            onKeyUp={(e) =>
                              e.key === "Enter" ? this.handleKeyDown(e) : null
                            }
                            validationOption={{
                              required: false
                            }

                            }
                            placeholder="Buscar..."
                            id="test"
                            name="test"
                            classNameInput={"form-control"}

                            value={this.state.filtrosRenovaciones.sucursal}
                            onChange={value => {

                              let nuevoObjeto = { ...this.state.filtrosRenovaciones, sucursal: value }
                              this.setState({
                                filtrosRenovaciones: nuevoObjeto
                              })
                            }}
                          />
                            : rowData.sucursal
                        }
                      /> */}

                      {/*  <Column
                        header="# Items Asegurados"
                        field="numeroitems"
                        sortable
                        style={{ width: "110px" }}
                      /> */}
                      {/*     <Column
                        header="Forma de Pago"
                        field="traMetodoPago"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/*   <Column
                        header="Estado Form. Vinculación"
                        field="estadoFormVinculacion"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/* <Column
                        header="Referencia"
                        field="refInterna"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/* <Column
                        header="Estado de Pago"
                        field="traEstadoPlacetoPay"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      {/* <Column
                        header="Estado de Firma"
                        field="estadoFirma"
                        sortable
                        style={{ width: "90px" }}
                      /> */}
                      {/*  <Column
                        header="Estado de Inspección"
                        field="estadoInspeccion"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      {/*     <Column
                        header="Valor"x
                        body={(rowData) => `$${rowData.total}`}
                        sortable
                        style={{ width: "100px" }}
                      /> */}

                      <Column
                        header="Suma asegurada anterior"
                        body={(rowData, options) => options.rowIndex === 0 ? '' : `$${rowData.sumaAsegurada}`}
                        style={{ width: "100px" }}
                      />
                      {/*    <Column
                        header="Estado"
                        field="estadoVer"
                        sortable
                        style={{ width: "100px" }}
                      />
 */}
                      <Column
                        className="counter"
                        field="estadoVer"

                        header="Estado"
                        style={{ width: "150px", overflow: "visible" }}
                        body={(rowData, options) =>
                          options.rowIndex === 0 ?

                            <Select
                              tabIndex="1" // Optional.[String or Number].Default: none.
                              id={"SelectRamo"} // Optional.[String].Default: "". Input ID.
                              name={"SelectRamo"} // Optional.[String].Default: "". Input name.
                              value={filtroValor} // Optional.[String].Default: "".
                              optionList={filtroselect} // Required.[Array of Object(s)].Default: [].
                              onChange={(selec, e) => {
                                this.setState({ filtroValor: selec });
                              }}
                              // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{
                                position: "absolute",
                                width: "200px",
                                minWidth: "150px",
                                maxWidth: "300px",
                                backgroundColor: "white",
                                zIndex: 1050,
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                              }}
                              validationOption={{
                                name: "SelectRamo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "",
                              }}
                            />



                            /*   <Textbox
    
                                tabIndex="1"
                                type="text"
                                onKeyUp={(e) =>
                                  e.key === "Enter" ? this.handleKeyDown(e) : null
                                }
                                validationOption={{
                                  required: false
                                }
    
                                }
                                placeholder="Buscar..."
                                id="test"
                                name="test"
                                classNameInput={"form-control"}
    
                                value={this.state.filtrosRenovaciones.reEstadoRenovacion}
                                onChange={value => {
    
                                  let nuevoObjeto = { ...this.state.filtrosRenovaciones, reEstadoRenovacion: value }
                                  this.setState({
                                    filtrosRenovaciones: nuevoObjeto
                                  })
                                }}
                              /> */
                            : <div>
                              <p>{rowData.estadoVer}</p>

                              {
                                rowData.estado == 'PROVISIONAL_SOLICITADA' &&
                                <p style={{ fontSize: 13 }}><strong>Vence: </strong> {rowData.fechaCobertura}</p>
                              }

                              {
                                (rowData.estado == 'NO_SINIESTROS_FIRMADA') &&
                                <p style={{ fontSize: 13 }}><strong>Vence: </strong> {rowData.fechaCarta}</p>
                              }
                            </div>
                        }
                      />

                      {/*   <Column
                        className="counter"
                        field="siniestralidad1"

                        header="Siniestralidad póliza"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>

                          options.rowIndex != 0 ?
                          rowData.siniestralidad1: ''
                        }
                      /> */}

                      {/*    <Column
                        className="counter"
                        field="siniestralidad2"

                        header="Siniestralidad actual"
                        style={{ width: "150px" }}
                        body={(rowData, options) =>

                          options.rowIndex != 0 ?
                          '0': ''
                        }
                      /> */}

                      <Column
                        header="Detalles"
                        body={(rowData, options) => options.rowIndex === 0 ? '' : this.bodyVerDetalles(rowData)}
                        sortable
                        style={{ width: "265px" }}
                      />


                    </DataTable>
                  </Card>
                </Col>
              </Row>
            </div>

          )}

          {this.state.datosRenovaciones.length === 0 && (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <Card className="mb-3">
                  <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                  <CardBody>
                    <h2 style={{ color: "#001871", textAlign: "center" }}>
                      {" "}
                      NO SE HA ENCONTRADO REGISTROS DE RENOVACIONES
                    </h2>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <ConfirmDialog
            isOpen={this.state.isConfirmOpen}
            toggle={this.toggleConfirm}
            message={this.state.message}
            onConfirm={() => {
              if (this.state.confirmAction) this.state.confirmAction();
            }}
          />


          <InputDialog
            titulo={this.state.titulo}
            isOpen={this.state.isInputOpen}
            toggle={this.toggleConfirmInput}
            email={this.state.email}
            setEmail={(email) => this.setState({ email: email })}
            error={this.state.errors}
            onConfirm={() => {
              if (this.state.confirmInputAction) this.state.confirmInputAction();
            }}
          />
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosRenovaciones: state.dataRenovaciones,
  datosUsuario: state.datosUsuarios.dataUsuario,
  datosUsuarios: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listadoDeRenovaciones: (param, ambiente, id, rangoFecha, filtros) => dispatch(FetchListadoRenovaciones(param, ambiente, id, rangoFecha, filtros)),
    descargarExcel: (param, ambiente, id, rangoFecha, filtros, history) => dispatch(FetchExportarEccel(param, ambiente, id, rangoFecha, filtros, history)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListaRenovaciones)
);

